uniform vec3 uColor;       // 光条の色（ハローのオレンジ）
uniform vec3 uCoreColor;   // 光源寄りの色（白）
uniform float uIntensity;  // 0-1。GSAP でフェード
uniform float uTime;
uniform float uAspect;     // プレーンの縦横比（角度を等方にするための補正）
uniform float uRayCount;   // 光条の本数感
uniform float uSharpness;  // 光条の細さ・鋭さ
uniform sampler2D uPerlinTexture;

varying vec2 vUv;

/*
 * 天体（プレーン中心）を光源として、全方向へ放射される
 * 細い光条の束（Edgerunners のレイの質感）。
 */
void main()
{
    // 中心原点・等方座標系（-1〜1、横はアスペクト補正）
    vec2 p = (vUv - 0.5) * 2.0;
    p.x *= uAspect;

    float dist = length(p);
    float angle = atan(p.y, p.x);

    // 光条: 角度方向のスポーク（ノイズでうねり、ゆっくり流れる）
    float wobble = texture2D(uPerlinTexture, vec2(angle * 1.5 + uTime * 0.008, 0.3)).r;
    float streak = pow(abs(sin(angle * uRayCount + wobble * 5.0 + uTime * 0.04)), uSharpness);

    // 筋ごとの長さ・明るさのばらつき
    float variation = texture2D(uPerlinTexture, vec2(angle * 3.0, 0.75)).r;

    // 光源ごく近傍は絞って惑星の白飛びを防ぎ、遠くまでゆるやかに減衰
    float nearFade = smoothstep(0.03, 0.28, dist);
    float farFade = 1.0 - smoothstep(0.8 + variation * 0.9, 1.7 + variation * 0.9, dist);

    /* 筋ごとに時間経過で大きく強弱をつける。
       ノイズを smoothstep で絞ることで、多くの筋がほぼ消えては
       ゆっくり戻る「呼吸」する見た目にして画面のうるささを抑える */
    float pulse = texture2D(uPerlinTexture, vec2(angle * 2.0 + 0.5, uTime * 0.035)).r;
    pulse = smoothstep(0.35, 0.8, pulse);
    pulse = 0.06 + 0.94 * pulse;

    float strength = streak * nearFade * farFade * pulse * (0.45 + 0.55 * variation);

    // 光源寄りは白、離れるほどオレンジ
    float closeness = pow(max(1.0 - dist * 0.7, 0.0), 2.0);
    vec3 color = mix(uColor, uCoreColor, closeness);

    // 加算ブレンドなので色・アルファ両方に強度を掛ける
    gl_FragColor = vec4(color * strength * uIntensity, strength * uIntensity);
}
